import {
  ComponentSize,
  type ComponentVariant,
} from 'src/modules/shared/types/component.type';
import { tagSizeClasses } from './tag.styles';
import { classes } from 'src/modules/shared/utils/styles.util';

interface TagSkeletonProps {
  size?: keyof typeof tagSizeClasses;
  variant?: ComponentVariant;
  containerClassName?: string;
  className?: string;
  withIcon?: boolean;
  iconPosition?: 'left' | 'right';
}

export const TagSkeleton: React.FC<TagSkeletonProps> = ({
  size = 'md',
  variant = 'neutral',
  containerClassName = '',
  className = '',
  withIcon = false,
  iconPosition = 'left',
}) => {
  const variantClasses: Record<ComponentVariant, string> = {
    primary: 'bg-primary-200',
    secondary: 'bg-secondary-200',
    danger: 'bg-danger-200',
    neutral: 'bg-neutral-200',
    warning: 'bg-warning-200',
    success: 'bg-success-200',
    info: 'bg-info-200',
    whatsapp: 'bg-whatsapp-200',
    call: 'bg-call-200',
    email: 'bg-email-200',
  };

  const bgClass = variantClasses[variant];
  const sizeClass = tagSizeClasses[size];
  const iconSizeMap: Record<ComponentSize, string> = {
    '2xs': 'h-2.5 w-2.5',
    xs: 'h-3 w-3',
    sm: 'h-3.5 w-3.5',
    md: 'h-4.5 w-4.5',
    lg: 'h-6 w-6',
  };

  const contentSizeMap: Record<ComponentSize, string> = {
    '2xs': 'h-3 w-12',
    xs: 'h-4 w-14',
    sm: 'h-5 w-16',
    md: 'h-7 w-20',
    lg: 'h-8 w-24',
  };

  const containerClasses = classes(
    'flex w-fit items-center justify-center gap-1 rounded-full animate-pulse',
    sizeClass,
    containerClassName
  );
  const tagClasses = classes(
    contentSizeMap[size],
    bgClass,
    'rounded-full',
    className
  );

  return (
    <div className={containerClasses}>
      {withIcon && iconPosition === 'left' && (
        <div className={`${iconSizeMap[size]} ${bgClass} rounded-full`} />
      )}

      <div className={tagClasses} />

      {withIcon && iconPosition === 'right' && (
        <div className={`${iconSizeMap[size]} ${bgClass} rounded-full`} />
      )}
    </div>
  );
};
